import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND } from "@/lib/config";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1e2a5a] text-[#f4f1ea] py-16 sm:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid sm:grid-cols-2 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="font-display text-2xl sm:text-3xl tracking-tight">
            {BRAND.name}
          </p>
          <p className="mt-3 text-sm italic font-display text-[#e5b3b3]">{t.brandSubtitle}</p>
          <p className="mt-6 max-w-md text-sm text-[#bdbdbd] leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="text-xs uppercase tracking-[0.22em] text-[#9a9a9a]">
            {t.footer.links}
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a href="#teacher" className="link-underline">
                {t.nav.teacher}
              </a>
            </li>
            <li>
              <a href="#courses" className="link-underline">
                {t.nav.courses}
              </a>
            </li>
            <li>
              <a href="#testimonials" className="link-underline">
                {t.nav.testimonials}
              </a>
            </li>
            <li>
              <a href="#contact" className="link-underline">
                {t.nav.contact}
              </a>
            </li>
            <li>
              <a
                href="/blog"
                data-testid="footer-blog-link"
                className="link-underline"
              >
                Blog · Solte seu francês — npdlbr
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.22em] text-[#9a9a9a]">
            Aulas de francês
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                href="/#aulas-de-frances"
                data-testid="footer-link-aulas-de-frances"
                className="link-underline"
              >
                Aulas de francês online
              </a>
            </li>
            <li>
              <a
                href="/#curso-online-frances"
                data-testid="footer-link-curso-online"
                className="link-underline"
              >
                Curso online de francês para brasileiros
              </a>
            </li>
            <li>
              <a
                href="/#aulas-online"
                data-testid="footer-link-aulas-online"
                className="link-underline"
              >
                Aulas particulares e em pequenos grupos
              </a>
            </li>
            <li>
              <a
                href="/#delf-dalf-tef-tcf"
                data-testid="footer-link-exams"
                className="link-underline"
              >
                Preparação DELF, DALF, TEF e TCF
              </a>
            </li>
            <li>
              <a
                href="/#professor-frances-nativo"
                data-testid="footer-link-prof"
                className="link-underline"
              >
                Professor de francês nativo de Paris
              </a>
            </li>
            <li>
              <a
                href="/#niveis"
                data-testid="footer-link-niveis"
                className="link-underline"
              >
                Aulas de francês por nível (A1 → C2)
              </a>
            </li>
            <li>
              <a
                href="/#a1"
                data-testid="footer-link-niveis-a1"
                className="link-underline"
              >
                Aulas de francês A1 · iniciante
              </a>
            </li>
            <li>
              <a
                href="/#a2"
                data-testid="footer-link-niveis-a2"
                className="link-underline"
              >
                Aulas de francês A2 · básico
              </a>
            </li>
            <li>
              <a
                href="/#b1"
                data-testid="footer-link-niveis-b1"
                className="link-underline"
              >
                Aulas de francês B1 · intermediário
              </a>
            </li>
            <li>
              <a
                href="/#b2"
                data-testid="footer-link-niveis-b2"
                className="link-underline"
              >
                Aulas de francês B2 · avançado
              </a>
            </li>
            <li>
              <a
                href="/#c1"
                data-testid="footer-link-niveis-c1"
                className="link-underline"
              >
                Aulas de francês C1 · autônomo
              </a>
            </li>
            <li>
              <a
                href="/#c2"
                data-testid="footer-link-niveis-c2"
                className="link-underline"
              >
                Aulas de francês C2 · maestria
              </a>
            </li>
            <li>
              <a
                href="/#aula-gratis"
                data-testid="footer-link-aula-gratis"
                className="link-underline"
              >
                Primeira aula grátis
              </a>
            </li>
            <li>
              <a
                href="/#contato-leadgen"
                data-testid="footer-link-contato"
                className="link-underline"
              >
                Reservar minha aula de francês
              </a>
            </li>
            <li>
              <a
                href="/#depoimentos"
                data-testid="footer-link-depoimentos"
                className="link-underline"
              >
                Depoimentos de alunos
              </a>
            </li>
            <li>
              <a
                href="/#faq"
                data-testid="footer-link-faq"
                className="link-underline"
              >
                Perguntas frequentes (FAQ)
              </a>
            </li>
            <li>
              <a
                href="/#solicitar-chamada"
                data-testid="footer-link-chamada"
                className="link-underline"
              >
                Solicitar uma chamada
              </a>
            </li>
            <li>
              <a
                href="/#cotacao"
                data-testid="footer-link-cotacao"
                className="link-underline"
              >
                Pedir uma cotação personalizada
              </a>
            </li>
            <li>
              <a
                href="/blog"
                data-testid="footer-link-blog-metodo"
                className="link-underline"
              >
                Solte.seu.francês — blog
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 mt-14 pt-8 border-t border-[#2a3766] flex flex-col sm:flex-row gap-4 sm:items-center justify-between text-xs text-[#9a9a9a]">
        <span>
          © {year} {BRAND.name}. {t.footer.rights}
        </span>
        <a
          href="/privacidade"
          data-testid="footer-privacy-link"
          className="link-underline hover:text-[#f4f1ea] transition-colors"
        >
          {t.footer.privacy}
        </a>
        <span className="font-display italic inline-flex items-center gap-2">
          <span aria-label="Bandeira da França" role="img">🇫🇷</span>
          França · Brasil
          <span aria-label="Bandeira do Brasil" role="img">🇧🇷</span>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
